function post(path, body, securityHeader) {
	const options = {
		credentials: 'omit',
		method: 'POST',
		headers: new Headers({
			'content-type': 'application/json;charset=UTF-8',
			'sec-fetch-mode': 'no-cors'
		}),
		mode: 'cors'
	};

	options.body = JSON.stringify(body);

	return fetch(`${path}`, options)
		.then(function(response) {
			return response.json();
		})
		.then(function(data) {
			return data;
		})
		.catch(err => {
			return err;
		});
}

async function customPost(path, securityHeader) {
	const options = {
		credentials: 'omit',
		method: 'POST',
		headers: new Headers({
			'sec-fetch-mode': 'no-cors'
		}),
		mode: 'cors'
	};

	return (
		fetch(`${path}`, options)
			.then(response => {
				return response.json();
			})
			// keep cors on the broweser extension *?????????????????////////////
			.then(subscriptions => {
				return subscriptions;
			})
			.catch()
	);
}

const http = {
	post: post,
	customPost: customPost
};

export default http;
